import React from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { CalendarBlank } from '@phosphor-icons/react';
import { Button } from '../ui/button';

const UpcomingVisitsBanner = ({ upcomingVisits }) => {
  const navigate = useNavigate();

  if (!upcomingVisits || upcomingVisits.length === 0) return null;

  return (
    <div className="mb-6" data-testid="upcoming-visits-banner">
      {upcomingVisits.map((visit) => (
        <motion.div
          key={visit.restaurant_id}
          initial={{ opacity: 0, y: -8 }}
          animate={{ opacity: 1, y: 0 }}
          className="flex items-center justify-between p-4 mb-2 rounded-xl bg-[#D1E2C4]/40 border border-[#4B5945]/20"
        >
          <div className="flex items-center gap-3 min-w-0">
            <CalendarBlank weight="duotone" className="w-5 h-5 text-[#4B5945] flex-shrink-0" />
            <div className="min-w-0">
              <p className="font-medium text-sm text-[#1A1918] truncate">
                {visit.name}
                {visit.suburb && <span className="text-[#7A7873] font-normal"> · {visit.suburb}</span>}
              </p>
              <p className="text-xs text-[#4B5945]">
                {visit.hours_until < 1
                  ? 'Less than an hour away'
                  : `In ${Math.round(visit.hours_until)} hours`}
                {visit.party_size && ` · Party of ${visit.party_size}`}
              </p>
            </div>
          </div>
          <Button
            onClick={() => navigate(`/restaurants/${visit.restaurant_id}`)}
            size="sm"
            variant="outline"
            className="flex-shrink-0 text-xs border-[#4B5945] text-[#4B5945]"
            data-testid={`view-upcoming-${visit.restaurant_id}`}
          >
            View
          </Button>
        </motion.div>
      ))}
    </div>
  );
};

export default UpcomingVisitsBanner;
